import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import Cookie from 'common/services/util/-RFC.Cookie';
import { Session, SessionKeys } from 'common/services/-RFC.session.js';

const _serviceDependencies = ['$scope', '$state', '$window', 'Auth', 'Util', '$location', 'JWT'];

/**
     * @ngdoc service
     * @name controllers.Reset
     *
     * @description
     * Reset password controller
     */
class Reset {

    /**
         * @param  {any} $scope
         * @param  {any} $window
         * @param  {any} $state
         * @param  {any} Auth
         * @param  {any} Util
         * @param  {any} JWT
         */
    constructor($scope, $state, $window, Auth, Util, $location, JWT) {

        this.Auth = Auth;
        this.Util = Util;
        this.$scope = $scope;
        this.$state = $state;
        this.$window = $window;
        this.$scope.submitted = false;
        this.Auth.error = false;
        this.Auth.loading = false;
        this.$scope.passwordRegExp = this.Util.getPasswordValidationRegExp();
        this.$scope.Auth = this.Auth;
        this.passwordScore = {};
        this.token = Cookie.get(CWCONFIG.cookie.token) || '';
        this.JWT = JWT;

        this.$scope.brandName = CWCONFIG.partnerConfig.name;

        Mixpanel.send('ConnectWeb Auth Reset Open', {
            Source: 'Email',
        });

        // if the flow is from SSO
        if (this.token) {

            // remove saved token from SSO if the reset page view is closed
            $scope.$on('$destroy', () => {

                Auth.removeLoginCookies();
                Session.setValue(SessionKeys.ExtraUrlParams, '');

            });

            // Save device id in session storage for launcher forgot flow
            const tokenPayload = this.JWT.getTokenPayload(this.token);
            if (tokenPayload.did) {

                localStorage.setItem('ResetEmailDeviceID', JSON.stringify(tokenPayload.did));

            }

            // delete query params
            const queryParams = $location.search();

            delete queryParams.client_id;
            $location.path('/auth/reset');

        } else {

            $location.path('/auth/login');

        }

    }

    resetPassword() {

        const resetPasswordPayload = {
            data: {
                type: 'passwords',
                relationships: {
                    partner: {
                        data: {
                            type: 'partners',
                            id: this.$window.appName,
                        },
                    },
                },
                attributes: {
                    password: this.$scope.password,
                },
            },
            meta: {
                logout: this.$scope.logoutFromAllDevices,
            },
        };

        const { token } = this;

        this.getPasswordScore(this.$scope.password);

        // Check if password and confirm password input fields are valid
        const formIsValid = this.$scope.resetPasswordForm.$valid &&
                              (this.$scope.resetPasswordForm.password.$viewValue ===
                              this.$scope.resetPasswordForm.passwordConfirm.$viewValue) &&
                              this.passwordScore.valid;

        Mixpanel.send('ConnectWeb Reset Password Click', {
            Page: 'Auth Reset',
        });

        this.$scope.submitted = true;

        if (formIsValid) {

            this.Auth.loading = true;
            this.Auth.resetPassword(resetPasswordPayload, token);

        } else {

            this.Util.triggerAnimation('.error', 'animated shake');

        }

    }

    showPassword() {

        const inputType = angular.element('#password')[0];

        if (inputType.type === 'text') {

            inputType.type = 'password';

        } else {

            inputType.type = 'text';

        }

        this.$scope.inputType = inputType.type;

    }

    getPasswordScore(password) {

        this.passwordScore = this.Util.getPasswordScore(password);

    }

}

_serviceDependencies.push(Reset);

angular.module('controllers')
    .controller('Reset', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/auth/reset/reset.js